import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { TopBorderCardComponent } from '@accredible-frontend-v2/new-components/top-border-card';
import { TwoColumnsLayoutComponent } from '@accredible-frontend-v2/new-components/two-columns-layout';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { AccredibleToastService } from '@accredible-frontend-v2/toast';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LockedAccountApiService } from './service/locked-account.service';

const TRANSLATION_PREFIX = 'acs-fa-locked-account';

@Component({
  selector: 'acs-locked-account',
  standalone: true,
  imports: [
    CommonModule,
    TopBorderCardComponent,
    TwoColumnsLayoutComponent,
    AccredibleButtonComponentModule,
    RouterModule,
    TranslocoModule,
  ],
  templateUrl: './locked-account.container.html',
  styleUrl: './locked-account.container.scss',
})
export class LockedAccountComponent {
  private readonly _lockedAccountApi = inject(LockedAccountApiService);
  private readonly _toast = inject(AccredibleToastService);
  private readonly _language = inject(AccredibleLanguageService);
  private readonly _route = inject(ActivatedRoute);

  lockedUserEmail = this._lockedAccountApi.getLockedUserEmail();

  resendRecoveryEmail(): void {
    this._lockedAccountApi.resendRecoveryEmail(this._route.snapshot.queryParams.origin).subscribe({
      next: () => {
        this._toast.success(this._language.translate(`${TRANSLATION_PREFIX}.toast.success`));
      },
      error: () => {
        this._toast.error(this._language.translate(`${TRANSLATION_PREFIX}.toast.error`));
      },
    });
  }
}
